







import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "@/components/dialog/index.vue";
import { Button } from "mint-ui";
import helpDialog from "./help";
import {shareToPlatform} from '@/utils/hybird'
@Component<VBANNER>({
  components: {
    dialogComp,
    "mt-button": Button,
  },
  methods:{
    goNext:()=>{

    },
    chuandi:()=>{

    }
  }
})
export default class VBANNER extends Vue {
  public tipType: number = 0; /* 0是已参与过活动，1是未中奖 */
  public tipError: string = "";
  public giftTip: string = "";
  public goNext2: any = () => {
    this.close();
    (this as any).goNext()
  };
  public chuandi2: any = () => {
    this.close();
  };
  public thanksImgs: string[] = [
    "https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/10.png",
    "https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/11.png",
    "https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/12.png",
    "https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/13.png",
  ];
  public getCurrentThankImg() {
    return this.thanksImgs[Math.floor(Math.random() * this.thanksImgs.length)];
  }
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
}
